import React from "react";

//material ui
import StorageIcon from "@material-ui/icons/Storage";
import Tooltip from "@material-ui/core/Tooltip";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItem from "@material-ui/core/ListItem";
import { withStyles } from "@material-ui/core/styles";

const IconContent = ({ handleClick, state, moduleName }) => {
  //this is a material ui feature where you can create a custom styled component based on the default one
  //they already have
  const StyledListItem = withStyles({
    root: {
      fontFamily: "Alegreya Sans, sans-serif",
      fontSize: "20px",
      color: state.theme === "dark" ? "#fa0171" : "#ffffff",
      textTransform: "capitalize",
    },
  })(ListItem);

  return (
    <StyledListItem button onClick={handleClick} id="queryModule">
      <ListItemIcon
        style={{ color: state.theme === "light" ? "#ffffff" : "#fa0171" }}
      >
        {!state.isSidebarOpen ? (
          <Tooltip title="Query Module" placement="right">
            <StorageIcon />
          </Tooltip>
        ) : (
          <StorageIcon />
        )}
      </ListItemIcon>
      {moduleName}
    </StyledListItem>
  );
};

export default IconContent;
